import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

/**
 * Styles for the in-drawer consent gate. Matches the GA-Sidekick Figma
 * "Version B: In-drawer modal" (frame `17525:31415`): a **60%-opacity
 * white backdrop** (`Scrim` `17525:32737` — white fill at opacity 0.6,
 * so the chat behind stays visible-through-dimmed, not hidden) with the
 * consent card (`17525:32738`) centered on top. The card reuses
 * `InlineMessageCard`, including its hairline border, 12px radius and
 * padding, and 16px gap.
 *
 * The privacy-statement link mirrors the package link convention
 * (`MessageBubble.styles.ts` `citationLink` / markdown `& a`):
 * `brand[600]`, underlined at rest, no underline on hover, pointer
 * cursor.
 */
const useStyles = makeStyles()((theme) => ({
  overlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.new.spacing.medium,
    backgroundColor: alpha(String(theme.new.color.common.white), 0.6),
  },
  card: {
    width: '100%',
  },
  link: {
    color: theme.new.color.brand[600],
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

export default useStyles;
